export default {
  space: process.env.NEXT_PUBLIC_EMD_SPACE || 'silk',
  apiEndpoint: process.env.NEXT_PUBLIC_ENDPOINT_API,
  bucketUrl: 'https://static.emd.one/silk/application',
  landingUrl: `https://${process.env.NEXT_PUBLIC_DOMAIN}` || 'https://gosilk.ru'
}
